import { TYPE_BOOLEAN } from './input-types';

export const id = 'gift';
export const apiKey = 'IsGift';
export const type = TYPE_BOOLEAN;

export const gift = {
  id,
  apiKey,
  type,
};
